export default __webpack_public_path__ + "static/media/image-32.4f9c761f.png";